module.exports = __webpack_public_path__ + "static/Delia-f27dcf861f538869da129726cae043ca.jpg";